import { httpRequest } from "@/lib";
import { useQuery } from "@tanstack/react-query";

export type TagData = {
  [category: string]: Tag[];
};

export interface Tag {
  id: string;
  tag: string;
  category: string;
  description: string;
  created_at: string;
  updated_at: string;
}

export interface RequestTagResponse {
  message: string;
  data: TagData;
}

export type TagResponse = TagData[];

async function fetchTags(context?: "contracts"): Promise<TagData> {
  const response = await httpRequest.get<TagData>(`/tags${context ? `?context=${context}` : ""}`);
  return response.data;
}

export function useFetchTagsQuery(context?: "contracts") {
  const tagsQuery = useQuery({
    queryKey: ["tags", context],
    queryFn: () => fetchTags(context),
    keepPreviousData: true,
  });

  return {
    ...tagsQuery,
    data: tagsQuery.data,
  };
}
